var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 12.0005V21.0005H21V11.1904L12 3.47607L3 11.1904V21.0005H6V12.0005H18ZM7.5 18H16.5V16.5H7.5V18ZM7.5 19.5V21H16.5V19.5H7.5ZM7.5 15H16.5V13.5H7.5V15ZM2.02381 10.051L12 1.5L21.9762 10.051C22.3087 10.336 22.5 10.752 22.5 11.1899V21C22.5 21.8284 21.8284 22.5 21 22.5H3C2.17157 22.5 1.5 21.8284 1.5 21V11.1899C1.5 10.752 1.69134 10.336 2.02381 10.051Z", fill: "#303030" })
  );
});